module.exports = __webpack_public_path__ + "1db6eea912eb2f56649aa1fefc47f4f4.pdf";